
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useState } from 'react';
import styles from '../../styles/home/threeFeaturesSection.module.scss';
export default function ThreeFeaturesSection() {
    const [expandedFeature, setExpandedFeature] = useState(0);
    return (<section className={styles.threeFeaturesSection}>
      <div className={styles.container}>
        <div className={styles.featuresGrid}>
          {/* Feature 1: Self-custody */}
          <div className={`${styles.featureCard} ${styles.feature1} ${expandedFeature === 0 ? styles.expanded : ''}`}>
            <div className={styles.featureHeader}>
              <h3 className={styles.featureTitle}>
                End-to-end self-custody architecture
              </h3>

              <button className={styles.featureButton} onClick={() => setExpandedFeature(expandedFeature === 0 ? -1 : 0)}>
                <span className={styles.buttonText}>
                  {expandedFeature === 0 ? 'View Less' : 'View More'}
                </span>
                <div className={`${styles.arrowIconWrapper} ${expandedFeature === 0 ? styles.arrowUp : ''}`}>
                  <div className={styles.arrowIcon}>
                    <img src="/images/icons/arrow-double-right.svg" alt="" role="presentation"/>
                  </div>
                </div>
              </button>
            </div>

            {expandedFeature === 0 && (<div className={styles.featureContent}>
                <p className={styles.description}>
                  Your assets always remain under your control on HFDX—never ours. Ownership is preserved across every layer of the system, including:
                </p>

                <ul className={styles.featureList}>
                  <li className={styles.listItem}>
                    <img src="/images/icons/checkmark.svg" alt="Checkmark" className={styles.checkIcon}/>
                    <span>Ethereum blockchain</span>
                  </li>
                  <li className={styles.listItem}>
                    <img src="/images/icons/checkmark.svg" alt="Checkmark" className={styles.checkIcon}/>
                    <span>ZKsync Layer 1 smart contracts and bridge</span>
                  </li>
                  <li className={styles.listItem}>
                    <img src="/images/icons/checkmark.svg" alt="Checkmark" className={styles.checkIcon}/>
                    <span>HFDX Layer 2 smart contracts</span>
                  </li>
                  <li className={styles.listItem}>
                    <img src="/images/icons/checkmark.svg" alt="Checkmark" className={styles.checkIcon}/>
                    <span>Your private keys</span>
                  </li>
                </ul>
              </div>)}
          </div>

          {/* Feature 2: Transaction Privacy */}
          <div className={`${styles.featureCard} ${styles.feature2} ${expandedFeature === 1 ? styles.expanded : ''}`}>
            <div className={styles.featureHeader}>
              <h3 className={styles.featureTitle}>
                Keep your
                <br />
                transactions private.
              </h3>

              <button className={styles.featureButton} onClick={() => setExpandedFeature(expandedFeature === 0 ? -1 : 0)}>
                <span className={styles.buttonText}>
                  {expandedFeature === 1 ? 'View Less' : 'View More'}
                </span>
                <div className={`${styles.arrowIconWrapper} ${expandedFeature === 1 ? styles.arrowUp : ''}`}>
                  <div className={styles.arrowIcon}>
                    <img src="/images/icons/arrow-double-right.svg" alt="" role="presentation"/>
                  </div>
                </div>
              </button>
            </div>

            <div className={styles.transactionVisual}>
              <img src="/images/features/transaction-complete.png" alt="Transaction privacy" className={styles.transactionImage}/>
            </div>
          </div>

          {/* Feature 3: Security */}
          <div className={`${styles.featureCard} ${styles.feature3} ${expandedFeature === 2 ? styles.expanded : ''}`}>
            <div className={styles.featureHeader}>
              <h3 className={styles.featureTitle}>
                Attack vectors fail without access to your private keys
              </h3>

              <button className={styles.featureButton} onClick={() => setExpandedFeature(expandedFeature === 0 ? -1 : 0)}>
                <span className={styles.buttonText}>
                  {expandedFeature === 2 ? 'View Less' : 'View More'}
                </span>
                <div className={`${styles.arrowIconWrapper} ${expandedFeature === 2 ? styles.arrowUp : ''}`}>
                  <div className={styles.arrowIcon}>
                    <img src="/images/icons/arrow-double-right.svg" alt="" role="presentation"/>
                  </div>
                </div>
              </button>
            </div>

            <div className={styles.securityVisual}>
              <img src="/images/features/security-visual.png" alt="Native Secure Key" className={styles.securityImage}/>
            </div>
          </div>
        </div>
      </div>
    </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3c7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ThreeFeaturesSection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3c7__ as getStaticProps }
  